module.exports = __webpack_public_path__ + "static/media/gallery-img-11.f5f73826.jpg";